import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { B2BApiUserComponent } from 'src/app/components/b2b/b2b-api-user/b2b-api-user.component';
import { B2BCreateShipmentComponent } from 'src/app/components/b2b/b2b-create-shipment/b2b-create-shipment.component';
import { B2bMainComponent } from 'src/app/components/b2b/b2b-main/b2b-main.component';
import { B2BShipmentListComponent } from 'src/app/components/b2b/b2b-shipments-list/b2b-shipments-list.component';
import { BecomeAB2BUserComponent } from 'src/app/components/b2b/become-a-b2b-user/become-a-b2b-user.component';
import { B2BDashboardGuard } from 'src/app/guards/b2b-dashboard.guard';
import { NoLoginGuard } from 'src/app/guards/no-login.guard';
import {B2BPickupsComponent} from '../../components/b2b/b2b-pickups/b2b-pickups.component';
import { B2BCreateShipmentOldComponent } from 'src/app/components/b2b/b2b-create-shipment-old/b2b-create-shipment-old.component';


const routes: Routes = [

  {
    path: "", redirectTo: 'sign-up', pathMatch: 'full'
  },
  {
    path:"contactus", component: B2bMainComponent
  },
  {
    path: "sign-up", component: BecomeAB2BUserComponent, canActivate: [NoLoginGuard]
  },
  {
    path: "create-shipment", component: B2BCreateShipmentComponent
  },
  {
    path: 'shipments', component: B2BShipmentListComponent, canActivate: [B2BDashboardGuard]
  },
  {
    path: 'dashboard', component: B2BApiUserComponent, canActivate: [B2BDashboardGuard]
  },
  {
    path: 'pickups', component: B2BPickupsComponent, canActivate: [B2BDashboardGuard]
  },
  {
    path: 'shipment-create', component: B2BCreateShipmentOldComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class B2BRoutingModule { }
